import { render, staticRenderFns } from "./ModalDiscrepanciaUmbrales.vue?vue&type=template&id=29680f30&scoped=true&"
import script from "./ModalDiscrepanciaUmbrales.vue?vue&type=script&lang=js&"
export * from "./ModalDiscrepanciaUmbrales.vue?vue&type=script&lang=js&"
import style0 from "./ModalDiscrepanciaUmbrales.vue?vue&type=style&index=0&id=29680f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29680f30",
  null
  
)

export default component.exports